// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"981edadf","453":"ef53cc85","796":"e8de5399"}[chunkId] + ".chunk.js";
};